import Columns from "../../../library/components/layout/Columns";
import Rows from "../../../library/components/layout/Rows";
import { Button } from "@mui/material";
import { appIcons } from "../../../app/appIcons";
import GenelDurumHelper from "../../../helpers/GenelDurumHelper";
import { KonserModel } from "../../../models/businessModels/KonserModel";
import SesGrupluKisiAvatarListControl from "../../../components/business/SesGrupluKisiAvatarListControl";
import KorocanImage from "../../../components/business/KorocanImage";
import { CsmText } from "../../../library/components/mui/CsmText";
import appColors from "../../../app/appColors";
import { BusinessHelper } from "../../../helpers/BusinessHelper";
import StringHelper from "../../../library/helpers/StringHelper";
import CsmIcerikHelper from "../../../library/helpers/CsmIcerikHelper";
import DateTimeToStringHelper from "../../../library/helpers/DateTimeToStringHelper";

interface IKonserPopupViewerProps {
    genelDurumHelper: GenelDurumHelper,
    konser: KonserModel,
    closer: (s: unknown) => void,
}

function KonserPopupViewer(props: IKonserPopupViewerProps) {
    const { closer, konser, genelDurumHelper } = props;
    const tumSarkilar = genelDurumHelper.SeciliKoroModel.sarkiOzetModelList;

    const sarkilar = konser.konserSarkiModelList.orderBy(e => e.siraNo).select(e => tumSarkilar.single(t => t.id === e.sarkiModelId));
    const kisiler = genelDurumHelper.SeciliKoroModel.hesapBilgiList.where(hesap => BusinessHelper.Kadro.HesapKadroyaDahilMi(hesap, konser.kadroModelId));

    const tumLinkler = konser.konserSarkiModelList.orderBy(e => e.siraNo).where(e => StringHelper.isNotEmpty(e.videoUrl)).select(e => {
        return {
            konserSarki: e,
            sarki: tumSarkilar.single(t => t.id === e.sarkiModelId),
        }
    });

    const getHeaderText = (title: string) => <CsmText bold style={{ width: "100%", marginBottom: "15px", textAlign: "center", borderBottomColor: appColors.BLACK, borderBottomStyle: "solid", borderBottomWidth: "1px" }}>{title}</CsmText>
    return (
        <Rows>
            <Columns>
                <CsmText note>{konser.yer} / {konser.sehirUlke} - {DateTimeToStringHelper.toMonthDayAndDayOfWeekString(konser.tarih, genelDurumHelper.translate)}</CsmText>
                {StringHelper.isNotEmpty(konser.ortakKoro) && <CsmText note italic>{` (${konser.ortakKoro} ile birliklte)`}</CsmText>}
            </Columns>
            <Columns pt={20}>
                <Rows width={150} mr={10}>
                    {getHeaderText("Konser Afişi")}
                    <KorocanImage
                        title={`${konser.isim} Afişi`}
                        icerikId={konser.resimIcerikId}
                        genelDurumHelper={genelDurumHelper}
                        style={{ maxHeight: "400px", maxWidth: "150px" }} />
                </Rows>
                <Rows mr={10} style={{ minWidth: "250px" }}>
                    {getHeaderText("Konser Eserleri")}
                    {sarkilar.map((sarki, i) => <CsmText key={i}>{`${(i + 1)}. ${sarki.isim}`}</CsmText>)}
                </Rows>
                <Rows mr={10}>
                    {getHeaderText("Konser Kadrosu")}
                    <SesGrupluKisiAvatarListControl
                        darkSeperator
                        tumHesaplar={genelDurumHelper.SeciliKoroModel.hesapBilgiList.where(e => BusinessHelper.Genel.KoristMi(e))}
                        gosterilecekHesaplar={kisiler}
                        hesapSesGrupGetir={BusinessHelper.SesGrubu.KadroyaGoreSesGruplariniGetir(konser.kadroModelId, genelDurumHelper)}
                        genelDurumHelper={genelDurumHelper} />
                </Rows>
            </Columns>
            {tumLinkler.length > 0 && <Rows>
                {getHeaderText("Konser Videoları")}
                <Columns wrap>
                    {tumLinkler.map(link =>
                        <Rows key={link.sarki.id} width={224} height={168} ml={10} mr={10} mb={30}>
                            <div className="video-responsive">
                                <iframe
                                    width="224"
                                    height="168"
                                    src={CsmIcerikHelper.findEmbedLink(link.konserSarki.videoUrl!)}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    title="Embedded youtube"
                                />
                            </div>
                            <CsmText note>{link.konserSarki.siraNo.toFixed()}. {link.sarki.isim}</CsmText>
                        </Rows>
                    )}
                </Columns>
            </Rows>
            }
            <Columns height={60} mt={10}>
                <Button color="info" variant="contained" onClick={() => closer(null)} style={{ flex: 1, margin: 10, marginRight: 0 }}>
                    {appIcons.Popup.tamam}
                    {genelDurumHelper.translate("Tamam")}</Button>
            </Columns>
        </Rows>
    );

}

export default KonserPopupViewer;